import { render, staticRenderFns } from "./block-rental-recoveries.vue?vue&type=template&id=5c9e7410&scoped=true&"
import script from "./block-rental-recoveries.vue?vue&type=script&lang=js&"
export * from "./block-rental-recoveries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9e7410",
  null
  
)

export default component.exports